export default "__VITE_ASSET__B75FtkC0__"